<style lang="scss" scoped>
@use "assets/scss/default.scss";
</style>

<template>
  <div class="h-screen flex flex-col">
    <!-- Header pinned at the top -->
    <Header :nav-links="navLinks" class="flex-shrink-0 mt-3 ml-3 mr-3 h-[80px]" />


    <!-- Navbar on the left with a fixed width and no growth -->
    <Navbar
      :navLinks="navLinks"
      class="flex-shrink-0 ml-3 absolute cconainter bottom-0 py-4"
    />

    <!-- Main flex container for navbar and main -->
    <div id="wrapper" class="flex flex-1 min-h-0 absolute p-4 overflow-auto">

      <!-- Main on the right, scrollable on overflow -->
      <main class="flex-1 min-h-0 h-full overflow-visible flex flex-col">
        <slot />
      </main>
    </div>
  </div>
</template>


<script setup>
import { navigationFor } from "~/utils/onboarding";

// The navigation follows the dashboard's mode (utils/onboarding.js, navigationFor): no plan, the guided getting started,
// or the full dashboard. `computed`: after a subscription or a change of mode, it updates without reloading the page.
// Each entry named in the person's language (`nav.<label>`).
const { t } = useI18n();
const { mode } = useSetupMode();
const docsUrl = useRuntimeConfig().public.docsUrl;
const navLinks = computed(() => navigationFor(mode.value, { docsUrl }).map((link) => ({ ...link, name: t(`nav.${ link.label }`) })));
</script>

<script>
export default {
  name: "DefaultLayout",
  mounted() {
    const { $events } = useNuxtApp();
    // Loader
    $events.on("loading", ([state, text, fullHeight]) => {
      this.loadingText = text || "loader.loading";
      this.loading = state;
      this.fullHeight = fullHeight;

      // If loading add overflow hidden
      if (state) document.body.classList.add("overflow-hidden");
      else document.body.classList.remove("overflow-hidden");
      // Move the scroll to the top
      window.scrollTo(0, 0);
    });
  }
};
</script>
